/**
 * Cartzilla | Bootstrap E-Commerce Template
 * Copyright 2020 Createx Studio
 * Theme core scripts
 *
 * @author Createx Studio
 * @version 1.4
 */
/*
 * updated for NFW fCZ-1.4
 * @author: René Panák (rene.panak@seznam.cz)
 */

let czTheme = null;

(function ($) {
    'use strict';

    function __consoleLog() {
        if (theme.__debug) {
            console.log.apply(this, arguments);
        }
    }

    function __consoleInfo() {
        if (theme.__debug) {
            console.info.apply(this, arguments);
        }
    }

    const theme = {

        /**
         * Theme's components/functions list
         * Comment out or delete the unnecessary component.
         * Some component have dependencies (plugins).
         * Do not forget to remove component plugin script from src/vendor/js
         */

        __debug: false,
        __stickyNavbar: false,

        init: () => {
            theme.debug($('#nfwTpl-debug').length > 0);

            theme.lazyloadInit();
            //theme.stickyNavbar();
            theme.stuckNavbarMenuToggle();
            theme.stickySidebar();
            theme.passwordVisibilityToggle();
            theme.formValidation();
            theme.multilevelDropdown();
            theme.scrollTopButton();
            theme.offcanvasSidebar();
            theme.tooltips();
            theme.popovers();
            theme.toasts();
            theme.disableDropdownAutohide();
            theme.carousel();

            if ('undefined' !== typeof lightGallery) {
                theme.gallery();
                theme.productGallery();
            }

            theme.rangeSlider();
            theme.filterList();
        },

        console: {
            log: __consoleLog,
            info: __consoleInfo,
            warn: console.warn,
            error: console.error
        },

        /**
         * @memberof theme
         * @method debug
         * @param {bool} debug
         * @returns {@var;debug|theme.__debug|Boolean}
         */
        debug: (debug = null) => {
            if (debug !== null) {
                theme.__debug = debug;
            }
            if (theme.__debug) {
                console.info('Debug mode is enabled!');
            }
            return theme.__debug;
        },
        /**
         * @memberof theme
         * @method isMobileView
         * @returns {bool}
         */
        isMobileView: () => {
            //console.log([$('#nfwTpl-mobile').is(':visible'),$('#nfwTpl-desktop').is(':visible')]);
            return $('#nfwTpl-mobile').is(':visible');
        },

        /**
         * @memberof theme
         * @method lazyloadInit
         */
        lazyloadInit: () => {

            // Set the options globally
            // to make LazyLoad self-initialize
            window.lazyLoadOptions = {
                // Your custom settings go here
            };
            // Listen to the initialization event
            // and get the instance of LazyLoad
            window.addEventListener(
                    "LazyLoad::Initialized",
                    function (event) {
                        window.lazyLoadInstance = event.detail.instance;
                        //console.log("LazyLoad::Initialized");
                    },
                    false
                    );
        },

        /**
         * @memberof theme
         * @method lazyloadUpdate
         */
        lazyloadUpdate: () => {
            if (window.lazyLoadInstance) {
                window.lazyLoadInstance.update();
                //console.log("LazyLoad::Update");
            }
        },

        /**
         * Enable sticky behaviour of navigation bar on page scroll
         * @todo colliding with open menu on mobile - cannot scroll trough menu!!!
         * @memberof theme
         * @method stickyNavbar
         */
        stickyNavbar: () => {

            let navbar = document.querySelector('.navbar-sticky');
            if (navbar === null) {
                return;
            }

            let navbarClass = navbar.classList,
                    navbarH = navbar.offsetHeight,
                    scrollOffsetTrigger = document.querySelector('div[role=main]').offsetTop,
                    sClass = 'navbar-stuck',
                    lastScrollOffset = 0;


            window.addEventListener('scroll', (e) => {
                //console.log(e);
                let scrollOffset = e.currentTarget.pageYOffset,
                        show = scrollOffset > scrollOffsetTrigger && scrollOffset - lastScrollOffset < 0,
                        change = show !== navbarClass.contains(sClass);
                //console.log(scrollOffset, show, lastScrollOffset);
                lastScrollOffset = scrollOffset;

                if (!change) {
                    return;
                }
                //console.log('stickyNavbar: upd; show =', show);

                if (show) {
                    document.body.style.paddingTop = navbarH + 'px';
                    navbarClass.add(sClass);
                } else {
                    document.body.style.paddingTop = '';
                    navbarClass.remove(sClass);
                }
            }, {passive: true});

            theme.__stickyNavbar = true;
        },

        /**
         * Stuck 3 level navbar menu toggle
         * @memberof theme
         * @method stuckNavbarMenuToggle
         */
        stuckNavbarMenuToggle: () => {

            let toggler = document.querySelector('.navbar-stuck-toggler'),
                    stuckMenu = document.querySelector('.navbar-stuck-menu');

            if (toggler === null) {
                return;
            }

            toggler.addEventListener('click', function (e) {
                stuckMenu.classList.toggle('show');
                e.preventDefault();
            });

        },

        stickySidebar: () => {

            if ('undefined' === typeof StickySidebar) {
                console.info('StickySidebar is not loaded');
                return null;
            }

            let element = document.querySelector('.sticky-sidebar');
            if (element === null) {
                return;
            }

            let sidebar = new StickySidebar(element, {
                //containerSelector: '#main-content',
                innerWrapperSelector: '.sticky-sidebar__inner',
                topSpacing: theme.__stickyNavbar ? 123 : 25, // to avoid collision with sticky menu
                bottomSpacing: 25,
                minWidth: 991
            });

        },

        /**
         * Toggling password visibility in password input
         * @memberof theme
         * @method passwordVisibilityToggle
         */
        passwordVisibilityToggle: () => {

            let elements = document.querySelectorAll('.password-toggle');

            for (let i = 0; i < elements.length; i++) {
                let passInput = elements[i].querySelector('.form-control'),
                        passToggle = elements[i].querySelector('.password-toggle-btn');

                passToggle.addEventListener('click', (e) => {

                    if (e.target.type !== 'checkbox')
                        return;
                    if (e.target.checked) {
                        passInput.type = 'text';
                    } else {
                        passInput.type = 'password';
                    }

                }, false);
            }
        },

        /**
         * From validation
         * @memberof theme
         * @method formValidation
         */
        formValidationBind: () => {
            let selector = 'needs-validation';

            let classBoundValidation = 'has-bound-validation';

            // Fetch all the forms we want to apply custom Bootstrap validation styles to
            let forms = document.getElementsByClassName(selector);
            // Loop over them and prevent submission
            let validation = Array.prototype.filter.call(forms, (form) => {

                if (form.classList.contains(classBoundValidation)) {
                    return;
                }

                form.addEventListener('submit', (e) => {
                    if (form.checkValidity() === false) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    form.classList.add('was-validated');
                }, false);

                form.classList.add(classBoundValidation);
            });
        },

        /**
         * From validation
         * @memberof theme
         * @method formValidation
         */
        formValidation: () => {
            window.addEventListener('load', theme.formValidationBind, false);
        },

        /**
         * Multilevel dropdown
         * @memberof theme
         * @method multilevelDropdown
         * @requires https://jquery.com/
         * @requires https://getbootstrap.com
         */
        multilevelDropdown: function () {

            let selector = ".dropdown-menu [data-toggle='dropdown']";

            $(selector).on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $(this).siblings().toggleClass('show');

                if (!$(this).next().hasClass('show')) {
                    $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
                }
                $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function () {
                    $('.dropdown-submenu .show').removeClass('show');
                });
            });
        },

        /**
         * Animate scroll to top button in/off view
         * @memberof theme
         * @method scrollTopButton
         */
        scrollTopButton: () => {

            let element = document.querySelector('.btn-scroll-top'),
                    scrollOffset = 600;

            if (element == null)
                return;

            let offsetFromTop = parseInt(scrollOffset, 10);

            window.addEventListener('scroll', (e) => {
                if (e.currentTarget.pageYOffset > offsetFromTop) {
                    element.classList.add('show');
                } else {
                    element.classList.remove('show');
                }
            });
        },

        /**
         * Off-canvas sidebar
         * @memberof theme
         * @method offcanvasSidebar
         */
        offcanvasSidebar: () => {

            let openTogglers = document.querySelectorAll('[data-toggle="sidebar"]'),
                    closeTogglers = document.querySelectorAll('[data-dismiss="sidebar"]'),
                    body = document.querySelector('body');

            for (let i = 0; i < openTogglers.length; i++) {
                openTogglers[i].addEventListener('click', (e) => {
                    e.preventDefault();
                    let sidebarID = e.currentTarget.getAttribute('href');
                    document.querySelector(sidebarID).classList.add('show');
                    body.classList.add('offcanvas-open');
                });
            }

            for (let i = 0; i < closeTogglers.length; i++) {
                closeTogglers[i].addEventListener('click', (e) => {
                    e.currentTarget.closest('.cz-sidebar').classList.remove('show');
                    body.classList.remove('offcanvas-open');
                });
            }
        },

        /**
         * Tooltips
         * @memberof theme
         * @method tooltips
         * @requires https://jquery.com/
         * @requires https://getbootstrap.com
         * @requires https://popper.js.org/
         */
        tooltips: () => {

            let selector = $('[data-toggle="tooltip"]');

            selector.tooltip();
        },

        /**
         * Popovers
         * @memberof theme
         * @method popovers
         * @requires https://jquery.com/
         * @requires https://getbootstrap.com
         * @requires https://popper.js.org/
         */
        popovers: () => {

            let selector = $('[data-toggle="popover"]');

            selector.popover();
        },

        /**
         * Toasts
         * @param {string} selector
         */
        toasts: () => {

            let selector = $('[data-toggle="toast"]');

            selector.on('click', function () {
                var target = $(this).data('target');
                $(target).toast('show');
            });
        },

        /**
         * Disable dropdown autohide when select is clicked
         * @memberof theme
         * @method disableDropdownAutohide
         */
        disableDropdownAutohide: () => {

            let elements = document.querySelectorAll('.disable-autohide .custom-select');

            for (let i = 0; i < elements.length; i++) {
                elements[i].addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }
        },

        /**
         * Content carousel with extensive options to control behaviour and appearance
         * @memberof theme
         * @method carousel
         * @requires https://github.com/ganlanyuan/tiny-slider
         */
        carousel: () => {
            let selector = '.cz-carousel .cz-carousel-inner';

            let classBoundCarousel = 'has-bound-carousel';

            // forEach function
            let forEach = function (array, callback, scope) {
                for (let i = 0; i < array.length; i++) {
                    callback.call(scope, i, array[i]); // passes back stuff we need
                }
            };

            // Carousel initialisation
            let carousels = document.querySelectorAll(selector);
            forEach(carousels, function (index, value) {

                if (value.classList.contains(classBoundCarousel)) {
                    return;
                }

                let defaults = {
                    container: value,
                    controlsText: ['<i class="czi-arrow-left"></i>', '<i class="czi-arrow-right"></i>'],
                    navPosition: 'bottom',
                    mouseDrag: true,
                    speed: 500,
                    autoplayHoverPause: true,
                    autoplayButtonOutput: false
                };
                let userOptions;
                if (value.dataset.carouselOptions != undefined) {
                    userOptions = JSON.parse(value.dataset.carouselOptions);
                }
                let options = {...defaults, ...userOptions};
                let carousel = tns(options);

                value.classList.add(classBoundCarousel);
            });
        },

        /**
         * Lightbox component for presenting various types of media
         * @memberof theme
         * @method gallery
         * @requires https://github.com/sachinchoolur/lightgallery.js
         */
        gallery: () => {

            let gallery = document.querySelectorAll('.cz-gallery');
            if (gallery.length) {
                for (let i = 0; i < gallery.length; i++) {
                    lightGallery(gallery[i], {
                        selector: '.gallery-item',
                        download: false,
                        videojs: true,
                        youtubePlayerParams: {
                            modestbranding: 1,
                            showinfo: 0,
                            rel: 0,
                            controls: 0
                        },
                        vimeoPlayerParams: {
                            byline: 0,
                            portrait: 0,
                            color: 'fe696a'
                        }
                    });
                }
            }
        },

        /**
         * Shop product page gallery with thumbnails
         * @memberof theme
         * @method productGallery
         * @requires https://github.com/sachinchoolur/lightgallery.js
         */
        productGallery: () => {

            let gallery = document.querySelectorAll('.cz-product-gallery');
            if (gallery.length) {

                for (let i = 0; i < gallery.length; i++) {

                    let thumbnails = gallery[i].querySelectorAll('.cz-thumblist-item:not(.video-item)'),
                            previews = gallery[i].querySelectorAll('.cz-preview-item'),
                            videos = gallery[i].querySelectorAll('.cz-thumblist-item.video-item');


                    for (let n = 0; n < thumbnails.length; n++) {
                        thumbnails[n].addEventListener('click', changePreview);
                    }

                    // Changer preview function
                    function changePreview(e) {
                        e.preventDefault();
                        for (let i = 0; i < thumbnails.length; i++) {
                            previews[i].classList.remove('active');
                            thumbnails[i].classList.remove('active');
                        }
                        this.classList.add('active');
                        gallery[i].querySelector(this.getAttribute('href')).classList.add('active');
                    }

                    // Video thumbnail - open video in lightbox
                    for (let m = 0; m < videos.length; m++) {
                        lightGallery(videos[m], {
                            selector: 'this',
                            download: false,
                            videojs: true,
                            youtubePlayerParams: {
                                modestbranding: 1,
                                showinfo: 0,
                                rel: 0,
                                controls: 0
                            },
                            vimeoPlayerParams: {
                                byline: 0,
                                portrait: 0,
                                color: 'fe696a'
                            }
                        });
                    }
                }
            }
        },

        /**
         * Range slider
         * @memberof theme
         * @method rangeSlider
         * @requires https://github.com/leongersen/noUiSlider
         */
        rangeSlider: () => {

            if ('undefined' === typeof noUiSlider) {
                console.info('noUiSlider is not loaded');
                return null;
            }

            let classBound = 'has-bound-range-slider';
            let selector = `.cz-range-slider:not(${classBound})`;
            let rangeSliderWidget = document.querySelectorAll(selector);

            for (let i = 0; i < rangeSliderWidget.length; i++) {

                let rangeSliderRoot = rangeSliderWidget[i],
                        rangeSlider = rangeSliderRoot.querySelector('.cz-range-slider-ui'),
                        valueMinInput = rangeSliderRoot.querySelector('.cz-range-slider-value-min'),
                        valueMaxInput = rangeSliderRoot.querySelector('.cz-range-slider-value-max'),
                        triggerInput = document.createElement('input');

                triggerInput.type = 'hidden';
                triggerInput.className = 'nfwE-filter-trigger';
                rangeSliderRoot.appendChild(triggerInput);

                let ds = rangeSliderRoot.dataset;

                let options = {
                    dataStartMin: parseFloat(ds.startMin),
                    dataStartMax: parseFloat(ds.startMax),
                    dataMin: parseInt(ds.min, 10),
                    dataMax: parseInt(ds.max, 10),
                    dataStep: parseFloat(ds.step) || 1,
                    dataUnitPre: ds.unitPre || '',
                    dataUnitPost: ds.unitPost || ''
                };

                noUiSlider.create(rangeSlider, {
                    start: [options.dataStartMin, options.dataStartMax],
                    connect: true,
                    step: options.dataStep,
                    pips: {mode: 'count', values: 5},
                    tooltips: true,
                    range: {
                        'min': options.dataMin,
                        'max': options.dataMax
                    },
                    format: {
                        to: function (value) {
                            return options.dataUnitPre + Math.round(parseFloat(value) * 100) / 100 + options.dataUnitPost;
                        },
                        from: function (value) {
                            return Number(value);
                        }
                    }
                });

                rangeSlider.noUiSlider.on('update', (values, handle) => {
                    let value = values[handle];
                    value = value.match(/^\D*(\d+([.,]\d+)?)\D*$/)[1];
                    if (handle) {
                        valueMaxInput.value = Math.round(value * 100) / 100;
                    } else {
                        valueMinInput.value = Math.round(value * 100) / 100;
                    }
                });

                rangeSlider.noUiSlider.on('change', (values, handle, unencoded, tap, positions, noUiSlider) => {
                    // values: Current slider values (array);
                    // handle: Handle that caused the event (number);
                    // unencoded: Slider values without formatting (array);
                    // tap: Event was caused by the user tapping the slider (boolean);
                    // positions: Left offset of the handles (array);
                    // noUiSlider: slider public Api (noUiSlider);
                    //console.log({values, handle, unencoded, tap, positions, noUiSlider});
                    let event = new Event('change', {bubbles: true});
                    triggerInput.dispatchEvent(event);
                });

                valueMinInput.addEventListener('change', function () {
                    rangeSlider.noUiSlider.set([this.value, null]);
                });

                valueMaxInput.addEventListener('change', function () {
                    rangeSlider.noUiSlider.set([null, this.value]);
                });

                rangeSliderRoot.classList.add(classBound);
            }

        },

        /**
         * Filter list of items by typing in the search field
         * @memberof theme
         * @method filterList
         */
        filterList: () => {

            let classBound = 'has-bound-filter-search';
            let selector = `.cz-filter:not(${classBound})`;
            let filterListWidget = document.querySelectorAll(selector);

            for (let i = 0; i < filterListWidget.length; i++) {

                let filterListRoot = filterListWidget[i],
                        filterInput = filterListRoot.querySelector('.cz-filter-search'),
                        filterList = filterListRoot.querySelector('.cz-filter-list'),
                        filterItems = filterList.querySelectorAll('.cz-filter-item');

                if (!filterInput || filterInput.classList.contains(classBound)) {
                    continue;
                }

                filterInput.addEventListener('keyup', filterListFunc);

                function filterListFunc() {

                    let filterValue = filterInput.value.toLowerCase();

                    for (let i = 0; i < filterItems.length; i++) {

                        let filterText = filterItems[i].querySelector('.cz-filter-item-text').innerHTML;

                        if (filterText.toLowerCase().indexOf(filterValue) > -1) {
                            filterItems[i].classList.remove('d-none');
                        } else {
                            filterItems[i].classList.add('d-none');
                        }

                    }

                }

                filterListRoot.classList.add(classBound);
            }
        },

    };

    /**
     * Init theme core
     */

    theme.init();

    czTheme = theme;

})(jQuery);
